import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import WebhooksSendMessageAPI from '../../api/webhooksSendMessage';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getWebhooksSendMessages(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  }
};

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isFetching: true });
    commit(types.SET_META, {});

    try {
      const { page, sortAttr, limit } = params;
      const response = await WebhooksSendMessageAPI.get(page, sortAttr, limit);

      commit(types.SET_WEBHOOKS_SEND_MESSAGES, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isCreating: true });

    try {
      const response = await WebhooksSendMessageAPI.create(data);

      commit(types.ADD_WEBHOOKS_SEND_MESSAGES, response.data);
      commit('integrations/SET_INTEGRATION_ENABLED', { appId: data.partner, enabled: true }, { root: true });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, data }) => {
    commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isUpdating: true });

    try {
      await WebhooksSendMessageAPI.update(id, { webhooks_send_messages: data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit, getters }, id) => {
    commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isDeleting: true });

    try {
      const partner = getters.getWebhooksSendMessages.find(r => r.id == id).partner
      await WebhooksSendMessageAPI.delete(id);
      const remaining = getters.getWebhooksSendMessages.filter(r => r.id !== id);
      commit('integrations/SET_INTEGRATION_ENABLED', { appId: partner, enabled: remaining.length > 0 }, { root: true });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },
  search: async ({ commit }, params) => {
    commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isFetching: true });
    commit(types.SET_META, {});

    try {
      const { page, sortAttr, search } = params;
      const response = await WebhooksSendMessageAPI.search(page, sortAttr, search);

      commit(types.SET_WEBHOOKS_SEND_MESSAGES, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_META](_state, data) {
    _state.meta = data;
  },

  [types.ADD_WEBHOOKS_SEND_MESSAGES]: MutationHelpers.create,
  [types.SET_WEBHOOKS_SEND_MESSAGES]: MutationHelpers.set,
  [types.DELETE_WEBHOOKS_SEND_MESSAGES]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
